var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.21054 11.71L11.8005 14.3C12.1905 14.69 12.8205 14.69 13.2105 14.3L15.8005 11.71C16.4305 11.08 15.9805 10 15.0905 10H9.91054C9.02054 10 8.58054 11.08 9.21054 11.71Z",
    fill: "#388078"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeMore);
export default __webpack_public_path__ + "static/media/seeMore.5e254bef8767525906f37a64c3085afe.svg";
export { ForwardRef as ReactComponent };